import i18next from 'i18next';

export const validate = data => {
  const errors = {};

  // DATA
  if (!data.name) {
    errors.name = i18next.t('validate_name');
  } else if (data.name && data.name.length < 2) {
    errors.name = i18next.t('at_least_two_characters');
  }

  // DATE
  if (data.date.startDate && !data.date.endDate) {
    const endDate = i18next.t('specify_end_date');
    errors.date = { endDate: i18next.t(endDate) };
  } else if (data.date.endDate && !data.date.startDate) {
    const startDate = i18next.t('specify_start_date');
    errors.date = { startDate: i18next.t(startDate) };
  } else if (!data.date.startDate && !data.date.endDate) {
    const date = i18next.t('specify_date');
    errors.date = { startDate: date, endDate: date };
  }

  // CONDITIONS
  if (!data.conditions.length) {
    errors.conditions = i18next.t('add_conditions');
  }

  return errors;
};
